import { GlueErrorDetail } from '@/src/lib/glue/types';

export class GlueApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly errors: Array<GlueErrorDetail>,
  ) {
    super(message);
  }
}

export class RequestPayloadError extends Error {
  constructor(
    message: string,
    public readonly status?: number,
  ) {
    super(message);
  }
}
